module.exports = __webpack_public_path__ + "img/6NP.2b2f4c0c.png";